import { notificationManager } from '../Stores/NotificationManager'

/**
 * Public API: reactive read of unread notifications counter.
 * Caller must be wrapped in observer() for the value to update.
 */
export const useUnreadNotificationCount = (): number => notificationManager.unreadCount
